export const resize1 = () => {
    setTimeout(function () {
        window.parent.postMessage({
                sentinel: 'amp',
                type: 'embed-size',
                height: document.body.scrollHeight,
            },
            '*'
        );
    }, 500);
}

export const resize2 = () => {
    setTimeout(function () {
        window.parent.postMessage({
                sentinel: 'amp',
                type: 'embed-size',
                height: document.body.scrollWidth * 0.8,
                width: document.body.scrollWidth
            },
            '*'
        );
    }, 500);
}

export const resize3 = () => {
    setTimeout(function () {
        window.parent.postMessage({
                sentinel: 'amp',
                type: 'embed-size',
                height: document.body.scrollWidth * 1.2,
                width: document.body.scrollWidth
            },
            '*'
        );
    }, 500);
}